import React, { useEffect, useState } from 'react';

import { WrapperUser, ContentUser, ImageUser } from './styles';

function CardUser({ user }) {
  const [phoneNumber, setPhoneNumber] = useState('');

  const regexPhoneNumber = () => {
    const regex = RegExp(/^\d+$/);
    if (regex.test(user.phone)) {
      return user.phone && user.phone.length >= 10
        ? `(${user.phone.substring(0, 2)}) ${user.phone.substring(3, 11)}`
        : user.phone;
    }
    return user.phone;
  };

  useEffect(() => {
    setPhoneNumber(regexPhoneNumber());
  }, [user.phone]);

  return (
    <WrapperUser>
      <ImageUser src={user.picture || `https://ui-avatars.com/api/?background=FF7700&color=fff&name=${user.name && user.name.replace(' ', '%20')}`} alt="usuário" />
      <ContentUser>
        <h3>{user.name}</h3>
        <h4>{user.email}</h4>
        <p>{phoneNumber}</p>
        <b>
          {user.qtd_last_tasks}
          {' '}
          {user.qtd_last_tasks === 1 ? 'pedido' : 'pedidos' }
          {' '}
          em 6 meses
        </b>
      </ContentUser>
    </WrapperUser>
  );
}

export default CardUser;
